<template>
  <v-dialog @click:outside="close()" v-model="dialog">
    <v-card color="white" id="program-container">
      <div id="cross-container">
        <img
          src="../assets/cross.svg"
          alt="close"
          id="close"
          @click="dialog = false"
        />
      </div>
      <h1 id="title">
        {{
          existing
            ? $t("soc-requirement.title-existing")
            : $t("soc-requirement.title-new")
        }}
      </h1>
      <div id="choose-mode">
        <span>{{ $t("soc-requirement.one-time") }}</span>
        <div id="switch-container">
          <v-switch
            id="switchBtn"
            color="#10367a"
            :readonly="existing"
            v-model="recurrent"
            inset
          ></v-switch>
        </div>
        <span>{{ $t("soc-requirement.recurrent") }}</span>
      </div>
      <div id="form-container">
        <div id="date-picker" v-if="!recurrent">
          <span class="program-label" id="aplication-day-label">{{
            $t("soc-requirement.application-day")
          }}</span>
          <v-menu
            v-model="datepicker"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <div id="date-field">
                <v-text-field
                  v-model="formatedDate"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                ></v-text-field>
              </div>
            </template>
            <v-date-picker
              color="#10367a"
              v-model="date"
              @input="datepicker = false"
              :locale="locale"
              first-day-of-week="1"
            ></v-date-picker>
          </v-menu>
        </div>
        <div v-else id="days-picker-container">
          <span class="program-label">{{
            $t("soc-requirement.application-days")
          }}</span>
          <div id="days-picker-selector">
            <div
              v-for="(day, index) in days"
              :id="day.letter"
              :key="index"
              class="day-square"
              :class="{ active: activeDay[index] }"
              @click="switchDayState(index)"
            >
              {{ day.letter }}
            </div>
          </div>
        </div>
        <div id="time-picker">
          <div id="time-label">
            <span class="program-label">{{
              $t("soc-requirement.start-day")
            }}</span>
          </div>
          <div id="hour-picker">
            <div class="date-dropdown">
              <v-select
                :v-if="hour"
                :items="timeTable[0]"
                v-model="hour"
                outlined
              ></v-select>
            </div>

            <span id="dot-dot">:</span>
            <div class="date-dropdown">
              <v-select
                :v-if="hour"
                :items="timeTable[1]"
                v-model="minute"
                outlined
              ></v-select>
            </div>
          </div>
        </div>

        <div id="charge-label">
          <span class="program-label">{{
            $t("soc-requirement.desired-charge")
          }}</span>
        </div>
        <div id="charge-info">
          <span v-if="getEstimates[charge]">{{
            `${getEstimates[charge].soc}% - ${getEstimates[charge].estimatedRange.km}km`
          }}</span>
        </div>
        <v-slider
          color="#10367a"
          v-model="charge"
          step="1"
          min="0"
          :max="sliderMax"
        ></v-slider>
      </div>
      <div id="action-container">
        <baseButton
          id="saveBtn"
          v-if="!existing"
          :value="$t('soc-requirement.save')"
          :action="save"
          :active="validInfo"
        />
        <baseButton
          class="delete-btn"
          v-if="existing"
          :value="$t('soc-requirement.delete')"
          white
          :action="deleteProgram"
        />
        <baseButton
          id="modifyBtn"
          v-if="existing"
          :value="$t('soc-requirement.save')"
          :action="modify"
          :active="validInfo"
        />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment-timezone'
import baseButton from '@/components/base-button.vue'
import { mapActions, mapGetters } from 'vuex'
import getEnv from '@/utils/env'

export default {
  data: () => ({
    existing: false,
    idProgram: '',
    dialog: false,
    recurrent: true,
    datepicker: false,
    date: '',
    charge: 0,
    hour: null,
    minute: null,
    activeDay: [false, false, false, false, false, false, false],
    buttonActivation: false,
    daysName: ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY']

  }),
  props: {
    update: { type: Function, required: true },
    dateSelected: { type: String, required: true }
  },
  components: {
    baseButton
  },
  computed: {
    ...mapGetters('vehicle', ['getCurrentVehicle', 'getEstimates']),
    days () {
      const dayLetter = this.$t('soc-requirement.letterDay').split('')
      var dayObject = []
      dayLetter.forEach((element, index) => {
        dayObject.push({ letter: element, active: this.activeDay[index], activated: this.buttonActivation })
      })
      return dayObject
    },
    locale () {
      return getEnv('VUE_APP_I18N_LOCALE')
    },
    validInfo () {
      if (this.buttonActivation || !this.buttonActivation) {
        return (this.activeDay.includes(true) || !this.recurrent)
      }
      return false
    },
    sliderMax () {
      return (this.getEstimates && this.getEstimates.length - 1 < 0) ? 13 : this.getEstimates.length - 1
    },
    formatedDate () {
      return moment(this.date).locale(getEnv('VUE_APP_I18N_LOCALE') ? getEnv('VUE_APP_I18N_LOCALE') : 'fr').format('D MMMM YYYY')
    },
    timeTable () {
      const minutes = []
      for (var i = 0; i < 60; i++) {
        minutes.push(i < 10 ? '0' + i : i.toString())
      }

      const hours = []
      for (var j = 0; j < 24; j++) {
        hours.push(j < 10 ? '0' + j : j.toString())
      }
      return [hours, minutes]
    }
  },
  methods: {
    ...mapActions('vehicle', ['addProgramOneTime', 'addProgramRecurrent', 'deleteProgramOneTime', 'deleteProgramRecurrent']),
    close () {
      this.dialog = false
    },
    open () {
      // create date object in the timezone of the vehicle to get it's current time
      const nDate = moment().tz(this.getCurrentVehicle.timezone)
      this.existing = false
      this.idProgram = ''

      this.activeDay = [false, false, false, false, false, false, false]
      this.recurrent = true
      this.charge = 7

      this.minute = nDate.format('mm')
      this.hour = nDate.format('HH')
      this.date = this.dateSelected !== '' ? this.dateSelected : nDate.format('YYYY-MM-DD')

      this.getEstimates.forEach((charge, index) => {
        if (charge.soc === 50) {
          this.charge = index
        }
      })

      this.dialog = true
    },
    openExisting (socRequirement) {
      this.existing = true

      const startDate = moment(socRequirement.start).tz(this.getCurrentVehicle.timezone)
      this.date = startDate.format('YYYY-MM-DD')
      this.minute = startDate.format('mm')
      this.hour = startDate.format('HH')
      this.recurrent = socRequirement.recurrent
      this.activeDay = [false, false, false, false, false, false, false]
      this.idProgram = socRequirement.id

      this.getEstimates.forEach((charge, index) => {
        if (charge.soc === parseInt(socRequirement.soc)) {
          this.charge = index
        }
      })
      if (socRequirement.recurrent) {
        this.daysName.forEach((day, index) => {
          if (socRequirement.days.includes(day)) {
            this.activeDay[index] = true
          }
        })
      }

      this.dialog = true
    },
    async saveRecurrent () {
      // create date object in the timezone of the vehicle
      console.warn(this.hour, this.minute)
      const day = moment().tz(this.getCurrentVehicle.timezone).minute(parseInt(this.minute), 'minutes').hour(parseInt(this.hour), 'hours')
      const addedHour = day.clone().add(getEnv('VUE_APP_PROGRAM_TIME_DURATION'), 'seconds')
      var daysOfWeek = []
      console.warn(day.format('HH:mm:[00]'), addedHour.format('HH:mm:[00]'), moment().tz(this.getCurrentVehicle.timezone).endOf('day').format('HH:mm:[00]'))
      const endTime = moment.min(moment().tz(this.getCurrentVehicle.timezone).endOf('day'), addedHour).format('HH:mm:[00]')

      // get the selected days
      this.activeDay.forEach((dayName, index) => {
        if (dayName) {
          daysOfWeek.push(this.daysName[index])
        }
      })

      // create an object to send to the back
      const body = {
        name: this.getCurrentVehicle.name,
        daysOfWeek: daysOfWeek,
        period: {
          from: `${this.hour}:${this.minute}:00`,
          to: endTime
        },
        recurrence: {
          from: day.toISOString()
        },
        soc: this.getEstimates[this.charge].soc
      }
      return this.addProgramRecurrent({ id: this.getCurrentVehicle.id, body })
    },

    async saveOneTime () {
      // create date object in the timezone of the vehicle
      const day = moment(this.date).tz(this.getCurrentVehicle.timezone).add(parseInt(this.minute), 'minutes').add(parseInt(this.hour), 'hours')
      const addedHour = day.clone().add(getEnv('VUE_APP_PROGRAM_TIME_DURATION'), 'seconds')
      const startISO = day.toISOString()
      const endISO = moment.min(moment(this.date).tz(this.getCurrentVehicle.timezone).endOf('day'), addedHour).toISOString()

      // create an object to send to the back
      const body = {
        name: this.getCurrentVehicle.name,
        period: {
          from: startISO,
          to: endISO
        },
        soc: this.getEstimates[this.charge].soc
      }

      return this.addProgramOneTime({ id: this.getCurrentVehicle.id, body })
    },

    async save () {
      if (this.recurrent) {
        await this.saveRecurrent()
      } else {
        await this.saveOneTime()
      }

      this.update()
      this.dialog = false
    },
    switchDayState (index) {
      this.activeDay[index] = !this.activeDay[index]
      this.buttonActivation = !this.buttonActivation
    },
    async modify () {
      if (this.recurrent) {
        await this.deleteProgramRecurrent(this.idProgram)
      } else {
      // create date object in the timezone of the vehicle
        const day = moment(this.date).tz(this.getCurrentVehicle.timezone)

        const startISO = day.toISOString()
        await this.deleteProgramOneTime({ id: this.idProgram, from: startISO })
      }
      this.save()
    },
    async deleteProgram () {
      if (this.recurrent) {
        await this.deleteProgramRecurrent(this.idProgram)
      } else {
      // create date object in the timezone of the vehicle
        const day = moment(this.date).tz(this.getCurrentVehicle.timezone)

        const startISO = day.toISOString()
        await this.deleteProgramOneTime({ id: this.idProgram, from: startISO })
      }

      this.update()
      this.dialog = false
    }
  }
}
</script>

<style>
.v-dialog {
  width: auto !important;
  border: 1px solid rgba(0, 0, 0, 0.7);
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) !important;
}

.day-square {
  width: 27px;
  height: 27px;
  border: solid 1px rgba(0, 0, 0, 0.5);
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.day-square:hover {
  border-color: black;
}

.program-label {
  font-weight: bold;
  font-size: 15px;
  line-height: 18px;
  color: #10367a;
  white-space: nowrap;
  margin-right: 5px;
}

.date-dropdown {
  width: 76px;
}

.active.day-square {
  background-color: #10367a;
  color: white;
}

.active.day-square:hover {
  background-color: #3166c2;
  color: white;
}

#close {
  cursor: pointer;
}

#cross-container {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-right: 48px;
  margin-top: 24px;
}

#program-container {
  width: 514px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

#switch-container {
  margin-left: 35px;
  margin-right: 20px;
}

#action-container {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 40px;
}

#choose-mode {
  margin-top: 34px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  color: #10367a;
}

#hour-picker {
  align-items: center;
  display: flex;
}

#application-day-container {
  margin-top: 20px;
  display: flex;
  align-items: center;
}

#form-container {
  margin-top: 40px;
  width: 314px;
  height: 290px;
}

#dot-dot {
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 30px;
}

#aplication-day-label {
  margin-bottom: 30px;
}

#days-picker-selector {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  width: 100%;
}

#days-picker-container {
  height: 86px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

#time-label {
  margin-bottom: 30px;
}

#date-field {
  width: 175px;
}

#date-picker {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

#modifyBtn {
  margin-left: 48px;
}

#charge-info {
  font-size: 14px;
  color: #1089ff;
  text-align: right;
  width: 100%;
}

#time-picker {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

#title {
  margin-top: 17px;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  text-align: center;
  color: #10367a;
}
</style>
